import React, { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import Select from '../Select';
import Icon from '../Icons';
import styles from './DaterangePicker.module.scss';
import moment from 'moment';
import DaterangePickerProps from './type';

const MyDateRangePicker: React.FC<{ onChange: (range: any) => void }> = ({ onChange }) => {
  const [selectionRange, setSelectionRange] = useState<DaterangePickerProps>({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });
  const [pristine, setPristine] = useState(true);
  const [showCalendar, setShowCalendar] = useState(false);

  const handleSelect = (ranges: any) => {
    setSelectionRange(ranges.selection);

    // if (ranges?.selection?.endDate !== selectionRange.endDate) {
    //   setShowCalendar(false);
    // }
    setPristine(false);

    if (onChange) {
      onChange({
        startDate: ranges.selection.startDate,
        endDate: ranges.selection.endDate,
        key: ranges.selection.key,
      });
    }
  };

  const generateLabel = (): string => {
    if (pristine) {
      return 'Pilih Tanggal';
    }

    const startDate = moment(selectionRange.startDate).format('DD MMM YYYY');
    const endDate = moment(selectionRange.endDate).format('DD MMM YYYY');
    const currentDate = moment().format('DD MMM YYYY');

    if (startDate === endDate && startDate === currentDate) {
      return 'Today';
    } else if (startDate === endDate) {
      return startDate;
    } else if (startDate !== endDate) {
      return `${startDate} - ${endDate}`;
    }
    return '';
  }

  return (
    <div className={styles['date-range']}>
      <Select hideOption iconLeft={<Icon name="Calendar" />} 
        onClick={() => { setShowCalendar(!showCalendar); }}
        onChange={() => { }} options={[
          {
            text: generateLabel(),
            value: `${moment(selectionRange.startDate).format('DD MMMM YYYY')} - ${moment(selectionRange.startDate).format('DD MMMM YYYY')}`
          },
        ]} value={`${moment(selectionRange.startDate).format('DD MMMM YYYY')} - ${moment(selectionRange.startDate).format('DD MMMM YYYY')}`} />
      {showCalendar && <div className={styles['date-range__calendar']}>
        <DateRangePicker
          ranges={[selectionRange]}
          onChange={handleSelect}
        />
      </div>}
    </div>
  );
};

export default MyDateRangePicker;